import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import { semanticColors } from 'design-system/tokens/colors';
import { effects } from 'design-system/tokens/effects';
import { bentoTokens } from '../bento-tokens';
import { DefaultPlaceholder } from './default-placeholder';

interface ZeroStateProps {
  placeholderSlot?: ReactNode;
  badgesSlot?: ReactNode;
  blur?: boolean;
}

/**
 * Bento Zero State (N=0 Images)
 *
 * Displays a placeholder when no images are available. Not clickable.
 * Still renders overlay badges (e.g. "Coming Soon") — an image-less listing
 * is exactly the case where a status badge matters most.
 */
export function BentoZeroState({ placeholderSlot, badgesSlot, blur }: ZeroStateProps) {
  return (
    <Box
      data-testid="gallery-bento-zero"
      sx={{
        position: 'relative',
        width: '100%',
        height: bentoTokens.height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: semanticColors.lightGray,
        borderRadius: bentoTokens.borderRadius.main,
        overflow: 'hidden',
        filter: blur ? effects.blur[100] : 'none',
      }}
    >
      {placeholderSlot || <DefaultPlaceholder />}
      {badgesSlot && (
        <Box
          sx={{
            position: 'absolute',
            top: bentoTokens.overlay.badges,
            left: bentoTokens.overlay.badges,
            zIndex: bentoTokens.zIndex.badges,
          }}
        >
          {badgesSlot}
        </Box>
      )}
    </Box>
  );
}
